import { Component } from "react";
import { LanguageContext } from "../i18n/LanguageContext";

// Catches render/runtime errors anywhere below it so users never see a blank white screen.
class ErrorBoundary extends Component {
  static contextType = LanguageContext;

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Full details stay in the console for developers; never shown to end users.
    console.error("Unhandled application error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleBackToEvents = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      const t = this.context?.t || ((_, fallback) => fallback);

      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-900 p-6 text-center">
          <div className="bg-slate-800/90 backdrop-blur-sm rounded-2xl shadow-2xl p-8 w-full max-w-md border border-slate-700/50">
            <h1 className="text-3xl font-bold text-white mb-3">
              ⚠️ {t("errorBoundary.title", "Something went wrong")}
            </h1>
            <p className="text-gray-300 mb-6">
              {t("errorBoundary.message", "An unexpected problem occurred. Please reload the page.")}
            </p>
            <div className="flex flex-col gap-3">
              <button
                onClick={this.handleReload}
                className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-3 rounded-lg font-semibold hover:from-blue-500 hover:to-indigo-500 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                🔄 {t("errorBoundary.reload", "Reload")}
              </button>
              <button
                onClick={this.handleBackToEvents}
                className="w-full bg-slate-700 border border-slate-600 text-white p-3 rounded-lg font-semibold hover:bg-slate-600 transition-all duration-200"
              >
                🎉 {t("errorBoundary.backToEvents", "Back to Events")}
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
